import styles from './Button.module.css';

const VARIANT_CLASS = {
  primary: styles.primary,
  secondary: styles.secondary,
  ghost: styles.ghost,
  outline: styles.outline,
  danger: styles.danger,
};

export default function Button({
  variant = 'primary',
  size = 'md',
  icon: Icon,
  iconPosition = 'left',
  children,
  className = '',
  type = 'button',
  ...rest
}) {
  const sizeClass = size === 'sm' ? styles.sm : size === 'lg' ? styles.lg : styles.md;
  return (
    <button
      type={type}
      className={`${styles.btn} ${VARIANT_CLASS[variant] || styles.primary} ${sizeClass} ${className}`}
      {...rest}
    >
      {Icon && iconPosition === 'left' && <Icon size={16} strokeWidth={2.25} />}
      {children && <span>{children}</span>}
      {Icon && iconPosition === 'right' && <Icon size={16} strokeWidth={2.25} />}
    </button>
  );
}
